module.exports = new __parcel__URL__("insight-schema-container-skeleton.tpl.33f9a64b.svg").toString();